import { createFileRoute } from "@tanstack/react-router";
import PrintWindowSticker from "@/pages/PrintWindowSticker";

export const Route = createFileRoute("/print/sticker/$slug")({
  component: PrintWindowSticker,
});
